import { useMutation } from 'react-relay';

import { searchHometaxRefundLoadEmployeeIncreaseMutation } from '@/__generated__/searchHometaxRefundLoadEmployeeIncreaseMutation.graphql';
import { searchHometaxRefundReloadMutation } from '@/__generated__/searchHometaxRefundReloadMutation.graphql';
import { searchHometaxRefundResultMutation } from '@/__generated__/searchHometaxRefundResultMutation.graphql';
import {
  searchHometaxRefundLoadEmployeeIncrease,
  searchHometaxRefundReload,
  searchHometaxRefundResult
} from '@/graphql/mutation/taxRefund/searchHometaxRefund';
import { BizMessageRequestType } from '@/lib/types/auth';

// 뮤테이션 설정을 위한 맵 정의
const MUTATION_CONFIG = {
  checkDecision: {
    query: searchHometaxRefundResult,
    type: {} as searchHometaxRefundResultMutation
  },
  recollect: {
    query: searchHometaxRefundReload,
    type: {} as searchHometaxRefundReloadMutation
  },
  job_retention: {
    query: searchHometaxRefundLoadEmployeeIncrease,
    type: {} as searchHometaxRefundLoadEmployeeIncreaseMutation
  }
} as const;

// 타입 추출을 위한 유틸리티 타입
type MutationType<T extends BizMessageRequestType> = (typeof MUTATION_CONFIG)[T]['type'];

const useSearchHometaxRefundResult = <T extends BizMessageRequestType>(requestType: T) => {
  const [commit, isInFlight] = useMutation<MutationType<T>>(MUTATION_CONFIG[requestType].query);

  return { commit, isInFlight };
};

export default useSearchHometaxRefundResult;
